import cmp from './BidList'

export default cmp
